<button type="button" [class]="showSuccessClass ? 'btn btn-success' : buttonClass" [disabled]="disabled || loading"
    #confirmButton (click)="onClick.emit($event)">
    <ng-content></ng-content>
    <div *ngIf="loading" class="spinner-border button-spinner" role="status">
        <span class="sr-only">Loading...</span>
    </div>
    <ng-container *ngIf="showSuccessClass">
        <i class="fas fa-check ms-1"></i>
    </ng-container>
</button>